/* Supporting page behavior, including sections inserted by the theme editor. */
(function () {
  'use strict';
  if (window.ASDPages) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root, editor) {
    root.querySelectorAll('[data-asd-topics]').forEach(function (group) {
      if (group.dataset.initialized) return;
      group.dataset.initialized = 'true';
      var section = group.closest('[data-section="blog-grid"]');
      group.addEventListener('click', function (event) {
        var button = event.target.closest('[data-asd-topic]');
        if (!button) return;
        var topic = button.dataset.asdTopic;
        group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b === button)); });
        var count = 0;
        section.querySelectorAll('[data-asd-article-tags]').forEach(function (item) {
          var tags = JSON.parse(item.dataset.asdArticleTags);
          item.hidden = topic !== 'all' && tags.indexOf(topic) === -1;
          if (!item.hidden) count++;
        });
        var empty = section.querySelector('[data-asd-topic-empty]');
        if (empty) empty.hidden = count > 0;
      });
    });
    if (!editor) return;
    root.querySelectorAll('.asd-reveal').forEach(function (node) { node.classList.add('is-in'); });
    root.querySelectorAll('[data-faq]').forEach(function (group) {
      if (group.dataset.asdInitialized) return;
      group.dataset.asdInitialized = 'true';
      group.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (item.open) group.querySelectorAll('details').forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
    root.querySelectorAll('[data-asd-carousel]').forEach(function (carousel) {
      if (carousel._asdRefresh) return;
      var track = carousel.querySelector('.asd-carousel__track');
      if (!track) return;
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var progress = carousel.querySelector('.asd-carousel__progress');
      var fill = carousel.querySelector('.asd-carousel__progress-fill');
      function paint() {
        var max = track.scrollWidth - track.clientWidth;
        if (progress) progress.hidden = max <= 1;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
        if (fill && max > 1) {
          var ratio = Math.max(0.12, track.clientWidth / track.scrollWidth);
          fill.style.width = ratio * 100 + '%';
          fill.style.transform = 'translateX(' + Math.max(0, Math.min(1, track.scrollLeft / max)) * (100 - ratio * 100) / ratio + '%)';
        }
      }
      function step(direction) {
        var item = track.querySelector('.asd-carousel__item');
        track.scrollBy({left: direction * ((item ? item.getBoundingClientRect().width : track.clientWidth) + (parseFloat(getComputedStyle(track).gap) || 0)), behavior: reduced ? 'auto' : 'smooth'});
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', paint, {passive: true});
      var observer = new ResizeObserver(paint);
      observer.observe(track);
      carousel._asdPagesCleanup = function () { observer.disconnect(); };
      carousel._asdRefresh = paint;
      paint();
    });
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target, true); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target, true); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-asd-carousel]').forEach(function (carousel) { if (carousel._asdPagesCleanup) carousel._asdPagesCleanup(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document, false); });
  else init(document, false);
  window.ASDPages = {init: init};
})();
